import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { EMPTY } from 'rxjs/internal/observable/empty';
import { of } from 'rxjs/observable/of';
import { catchError, mergeMap } from 'rxjs/operators';
import { take } from 'rxjs/operators/take';

import { LoadingService } from '@finder/shared/services/loading-service/loading-service.service';
import { FinderApiConnectorService } from '@finder/shared/services/finder-api-connector/finder-api-connector.service';

@Injectable()
export class SearchResolver implements Resolve<Object> {

    constructor(
        private loadingSvc: LoadingService,
        private finderApi: FinderApiConnectorService,
    ) { }

    resolve(route: ActivatedRouteSnapshot) {
        // Here we call the services to get the data ready
        // for the search page

        // Reset of Error state to avoid getting Error message stuck after back button pressed GIT-31197
        this.loadingSvc.setErrorState(null);
        this.loadingSvc.setLoadingState(false);

        const routeSearchQuery = route.queryParams['searchQuery'];

        return this.finderApi.getSearchQuery(routeSearchQuery, 0)
            .pipe(
                catchError((error) => {
                    this.loadingSvc.setErrorState(error);
                    this.loadingSvc.setLoadingState(true);
                    return EMPTY;
                }),
                mergeMap((result: any) => {
                    this.loadingSvc.setLoadingState(true);
                    result.term = routeSearchQuery;
                    return of(result);
                }),
                take(1)
            );
    }
}
